export const prefixTranslation = 'administration.externalCourses'
